import script from "./Recharge.vue?vue&type=script&setup=true&lang=js"
export * from "./Recharge.vue?vue&type=script&setup=true&lang=js"

import "./Recharge.vue?vue&type=style&index=0&id=2683b48e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2683b48e"]])

export default __exports__